module.exports = __webpack_public_path__ + "static/image-01-b@2x-c4d8ea9a92af38e22acf62c75901b235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cabify/image-01-b@2x.jpg
// module id = 337
// module chunks = 3627797113349 20562973939449 33019919093843